import React from 'react';
import { Box, Typography } from '@mui/material';
import { APP_NAME_FULL, APP_NAME_SHORT } from '../appMeta';
import { LAYOUT_MAIN_GUTTER_PX, LAYOUT_SURFACE } from '../layout/layoutColors';

type LayoutFooterProps = {
  /** Viewport offset from the left (e.g. persistent drawer width). */
  leftOffsetPx?: number;
};

export function LayoutFooter({ leftOffsetPx = 0 }: LayoutFooterProps) {
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        left: leftOffsetPx,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        py: 1.5,
        px: `${LAYOUT_MAIN_GUTTER_PX}px`,
        bgcolor: LAYOUT_SURFACE,
        borderTop: 1,
        borderColor: 'divider',
        boxSizing: 'border-box',
      }}
    >
      <Typography variant="body2" color="text.secondary" align="center" title={APP_NAME_FULL}>
        {APP_NAME_SHORT}
      </Typography>
    </Box>
  );
}
